import styled, { css } from 'styled-components';

export const Container = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  transition: background-color 0.15s ease;
  border: 0;
  font-weight: normal;
  width: max-content;

  ${(props) => {
    const validColors = Object.keys(props.theme.button.colors);
    const validSizes = Object.keys(props.theme.button.sizes);
    const color = validColors.includes(props.color) ? props.color : 'default';
    const size = validSizes.includes(props.size) ? props.size : 'default';

    return css`
      background-color: ${props.theme.button.colors[color].bg};
      color: ${props.theme.button.colors[color].font};

      & > span.btn-text {
        color: ${props.theme.button.colors[color].font};
        svg {
          fill: ${props.theme.button.colors[color].font};
          stroke: ${props.theme.button.colors[color].font};
        }
      }

      &:hover {
        background-color: ${props.theme.button.colors[color].hoverColor};
        color: ${props.theme.button.colors[color].hoverFontColor};
        & > span.btn-text {
          color: ${props.theme.button.colors[color].hoverFontColor};
          svg {
            fill: ${props.theme.button.colors[color].hoverFontColor};
            stroke: ${props.theme.button.colors[color].hoverFontColor};
          }
        }
      }

      padding: ${(props) => props.theme.button.sizes[size].padding};
      font-size: ${(props) => props.theme.button.sizes[size].fontSize};
      height: ${(props) => props.theme.button.sizes[size].height};
      min-height: ${(props) => props.theme.button.sizes[size].height};

      &:disabled,
      &[disabled] {
        opacity: 0.6;
        cursor: not-allowed;
        background-color: ${props.theme.button.colors[color].bg};

        &:hover {
          background-color: ${props.theme.button.colors[color].bg};
          color: ${props.theme.button.colors[color].font};
        }
      }
    `;
  }}

  & > span.btn-text {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin: 0;
    opacity: 1;
    transition: opacity 300ms ease;

    svg {
      &:first-child {
        margin-right: 5px;
      }
      &:last-child {
        margin-left: 5px;
      }
    }
  }

  .loader {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 300ms ease;
  }

  &.btn-block {
    width: 100%;
  }

  &.btn-loading {
    > span {
      opacity: 0;
    }
    .loader {
      opacity: 1;
    }
  }

  ${(props) =>
    props.loading &&
    css`
      svg {
        margin-right: 5px;
        animation: spin 2s linear infinite;
      }
    `}

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
